var initializeDealerLocatorBlock = function(block){

	var map = initMap(jQuery('#locations-map'));
	
	setupLocationForm(map);

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-dealer-locator').each(function(){
		initializeDealerLocatorBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=dealer-locator', initializeDealerLocatorBlock);
	

function setupLocationForm(map){
	
	jQuery('#locations-search').on('submit', function(e){
		
		e.preventDefault(); 
		
		var address = jQuery('#address').val();
		
		jQuery('#locations-container').addClass('loading');
		
		getNearestDealers(map, address);
		
	});
	
}

function getNearestDealers(map, address = ''){
	
	var radius = jQuery('#locations-map').data('radius');
	
	jQuery.ajax({
		url:"/wp-admin/admin-ajax.php",
		type:'POST',
		data:'action=get_nearest_dealers&address='+ address + '&radius=' + radius,
		success:function(results){

			var dealerData = JSON.parse(results);
			var dealerHTML = '';
			
			for(var i=0; i<dealerData.dealers.length; i++) {
				dealerHTML = dealerHTML + dealerData.dealers[i].html;
			}
			
			if(address) {
				jQuery('#locations-container').addClass('has-results');
			}
			
			jQuery('#locations').html(dealerHTML);
			jQuery('#locations-container').removeClass('loading');
			jQuery('#locations').scrollTop(0);
			
			setupMarkers(map, dealerData, address);
			centerMap(map);
			
			if(!dealerData.dealers.length) {
				jQuery('#no-locations').removeClass('hide');
			} else {
				jQuery('#no-locations').addClass('hide');
			}
		}
	});
	
}

function initMap(mapContainer){

	var mapArgs = {
		zoom        		: mapContainer.data('zoom') || 16,
		mapTypeControl		: false,
		scaleControl		: false,
		streetViewControl	: false,
		rotateControl		: false,
		fullscreenControl	: false,
		styles  			: mapStyles
	};
	
	var map = new google.maps.Map(mapContainer[0], mapArgs);
	
	getNearestDealers(map);
	
	return map;

}

function setupMarkers(map, dealerData, address = false){
	
	var dealers = dealerData.dealers;
	
	if(map.markers){
		for(var i = 0; i < map.markers.length; i++){
			map.markers[i].setMap(null);
		}
	}
	
	map.markers = [];
	
	for(var i=0; i<dealers.length; i++){
	   initMarker(dealers[i], map);
	}
	
	if(dealerData.user.lat) {
		
		var latLng = {
			lat: dealerData.user.lat,
			lng: dealerData.user.lng
		};
		
		console.log(latLng);
		
		var marker = new google.maps.Marker({
			map			: map,
			position 	: latLng,
			icon 		: { 
				url			: '/wp-content/themes/plumbweb-child/_assets/img/map-icon-pin.svg', 
				size		: new google.maps.Size(24, 30),
				scaledSize	: new google.maps.Size(24, 30)
			}
		});
		
		map.markers.push(marker);
		
	}
	
}

function initMarker(dealer, map){

	var latLng = {
		lat: dealer.lat,
		lng: dealer.lng
	};

	var marker = new google.maps.Marker({
		map			: map,
		position 	: latLng,
		icon 		: { 
			url			: '/wp-content/themes/plumbweb-child/_assets/img/map-icon-dealer.svg', 
			size		: new google.maps.Size(18, 18),
			scaledSize	: new google.maps.Size(18, 18)
		}
	});
	
	marker.set("id", dealer.id);
	map.markers.push(marker);
	
	google.maps.event.addListener(marker, 'click', function(){
				
		var locations= jQuery('#locations');
		var locationID = this.get('id');
		var locationContainer = jQuery('[data-id='+locationID+']', locations);
		var locationContainerOffset = locationContainer[0].offsetTop - locations[0].offsetTop;
		
		jQuery('#locations .location').removeClass('active');
		
		locationContainer.addClass('active');
		
		locations.animate({ scrollTop: locationContainerOffset }, 500);
		
	});
	
}
		
function centerMap(map){
	
	if(map.markers.length){
	
		var bounds = new google.maps.LatLngBounds();
		
		for(var i=0; i<map.markers.length; i++){
			
			bounds.extend({
				lat: map.markers[i].position.lat(),
				lng: map.markers[i].position.lng()
			});
			
		}
	
		if(map.markers.length == 1){
			map.setCenter(bounds.getCenter());
	
		} else{
			map.fitBounds(bounds);
		}
	
	}else{
		map.setCenter({lat:39.5800363, lng:-95.8198895});
		map.setZoom(4);
	}
}
	